import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSubscription = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M29 7C30.0544 7 30.9182 7.81588 30.9945 8.85074L31 9V23C31 24.0544 30.1841 24.9182 29.1493 24.9945L29 25H24V23H29V9H24V7H29ZM8 7V9H3V23H8V25H3C1.94564 25 1.08183 24.1841 1.00549 23.1493L1 23V9C1 7.94564 1.81588 7.08183 2.85074 7.00549L3 7H8ZM20 5H12C10.8954 5 10 5.89543 10 7V25C10 26.1046 10.8954 27 12 27H20C21.1046 27 22 26.1046 22 25V7C22 5.89543 21.1046 5 20 5ZM12 7H20V25H12V7Z" })
});
export default SvgSubscription;
